import { render, staticRenderFns } from "./InfoTest.vue?vue&type=template&id=3afd2e79&scoped=true"
import script from "./InfoTest.vue?vue&type=script&lang=js"
export * from "./InfoTest.vue?vue&type=script&lang=js"
import style0 from "./InfoTest.vue?vue&type=style&index=0&id=3afd2e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd2e79",
  null
  
)

export default component.exports